import {downloadExportFileV2} from '@/utils/api';
import {getApiUrl} from '@/api/common-utils';
import {BaseApi} from '@/api/base-api';

class IndexingApi extends BaseApi {
  private static readonly baseUrl: string = getApiUrl(BaseApi.LINKGRAPH_ENDPOINT, '/api/v1');
  private static readonly baseUrlV2: string = getApiUrl(BaseApi.LINKGRAPH_ENDPOINT, '/api');

  // post api
  public async postIndexing(payload, publicHash?: string) {
    if (publicHash) {
      publicHash['hash'] = publicHash;
    }
    try {
      const response = await this.axios.post(`${IndexingApi.baseUrl}/indexing-batches/submit/`, payload, {

        cancelToken: this.cancelToken,
      });
      return response.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  // get api
  public async loadIndexingBatches(payload, publicHash?: string) {
    const params = payload;
    if (publicHash) {
      params['hash'] = publicHash;
    }
    try {
      const response = await this.axios.get(`${IndexingApi.baseUrl}/indexing-batches/`, {

        cancelToken: this.cancelToken,
        params,
      });
      return response.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }
  public async getIndexingBatchById(id, params?: any, publicHash?: string) {
    if (publicHash) {
      params['hash'] = publicHash;
    }
    try {
      const response = await this.axios.get(`${IndexingApi.baseUrl}/indexing-batches/${id}/links/`, {

        cancelToken: this.cancelToken,
        params,
      });
      return response.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }
  public async getIndexingChartHistory(id, publicHash?: string, params?: any) {
    if (publicHash) {
      params['hash'] = publicHash;
    }
    try {
      const response = await this.axios.get(`${IndexingApi.baseUrl}/indexing-batches/${id}/history`, {

        cancelToken: this.cancelToken,
        params,
      });
      return response.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  // export api
  public async exportIndexingBatches(id) {
    try {
      const url = `${IndexingApi.baseUrl}/indexing-batches/${id}/download-report/`;
      await downloadExportFileV2(url, `indexing_batches.csv`);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
export const INDEXING_API = new IndexingApi();
